import { useEffect, useState, useCallback } from 'react'

export const useGetHeaderOffset = ({ isSideMenu }) => {
  const calculateOffset = () => {
    const headerElement = document.querySelector('header')
    const headerYPosition = headerElement?.getBoundingClientRect?.()?.y || 0
    const headerHeight = headerElement?.offsetHeight || 0
    return headerYPosition < headerHeight * -1 ? 0 : headerHeight + headerYPosition
  }

  const [headerOffset, setHeaderOffset] = useState(calculateOffset())

  const eventListenerCallback = useCallback(() => {
    setHeaderOffset(calculateOffset())
  }, [])

  useEffect(() => {
    if (isSideMenu) {
      document.addEventListener('scroll', eventListenerCallback)
    }
    return () => {
      document.removeEventListener('scroll', eventListenerCallback)
    }
  }, [])

  return {
    headerOffset: headerOffset || 0,
  }
}
